export default "__VITE_ASSET__DeQ6WRIa__"